export const faqText = {
  title: "Häufige Fragen",
  subtitle: "Antworten auf Ihre Fragen zum Angelverein",
};

export const faqData = [
  {
    question: "Welche Arten von Mitgliedschaften bieten Sie an?",
    answer: "Wir bieten verschiedene Mitgliedschaftsoptionen an, darunter Jahresmitgliedschaften, Familienmitgliedschaften und Gastmitgliedschaften für gelegentliche Angler."
  },
  {
    question: "Wie kann ich Mitglied im Angelverein werden?",
    answer: "Um Mitglied zu werden, können Sie unser Anmeldeformular auf der Website ausfüllen oder uns direkt per E-Mail oder Telefon kontaktieren. Wir helfen Ihnen gerne bei der Anmeldung."
  },
  {
    question: "Gibt es einen Angelkurs für Anfänger?",
    answer: "Ja, wir bieten regelmäßig Angelkurse für Anfänger an, in denen Sie die Grundlagen des Angelns lernen, von der Ausrüstung bis hin zu verschiedenen Angeltechniken."
  },
  {
    question: "Wie kann ich mich für einen Angelwettbewerb anmelden?",
    answer: "Die Anmeldung zu unseren Angelwettbewerben erfolgt online über unsere Website. Dort finden Sie alle Details zu den kommenden Veranstaltungen sowie das Anmeldeformular."
  },
  {
    question: "Welche Angelgewässer gehören zum Angelverein?",
    answer: "Unser Verein besitzt mehrere Gewässer, die regelmäßig gepflegt werden. Dazu gehören sowohl stehende als auch fließende Gewässer, in denen verschiedene Fischarten zu finden sind."
  },
  {
    question: "Sind die Gewässer auch für Kinder zugänglich?",
    answer: "Ja, unsere Gewässer sind auch für Kinder zugänglich. Wir bieten kinderfreundliche Angeltage an und stellen sicher, dass sie unter Anleitung sicher angeln können."
  },
  {
    question: "Wie funktioniert das Fischen mit der Vereinsausrüstung?",
    answer: "Die Nutzung der Vereinsausrüstung ist für Mitglieder kostenfrei. Sie können die Ausrüstung zu den regulären Öffnungszeiten im Vereinshaus ausleihen. Eine kurze Einweisung wird vor der Nutzung gegeben."
  },
  {
    question: "Gibt es bestimmte Regeln für das Angeln in unseren Gewässern?",
    answer: "Ja, es gibt bestimmte Angelvorschriften, wie z.B. Fangbeschränkungen, Angelzeiten und erlaubte Angelmethoden. Diese Regeln helfen, die Fischbestände nachhaltig zu bewahren und ein faires Angeln zu gewährleisten."
  },
  {
    question: "Bietet der Verein Ausflüge oder Angeltouren an?",
    answer: "Ja, wir organisieren regelmäßig Ausflüge und Angeltouren, sowohl für Mitglieder als auch für Interessierte. Diese Touren bieten eine großartige Gelegenheit, neue Angeltechniken zu erlernen und gemeinsam zu angeln."
  },
  {
    question: "Wie kann ich mit anderen Mitgliedern in Kontakt treten?",
    answer: "Wir bieten eine Mitgliederplattform auf unserer Website an, über die Sie Nachrichten austauschen, Veranstaltungen organisieren und sich über Angeltechniken austauschen können. Außerdem finden regelmäßig Vereinsabende statt, bei denen Mitglieder sich persönlich treffen können."
  },
];
